import { useAuth } from '@/contexts/AuthContext';

// Tier pro removido do catálogo (20260703150000_remove_pro_tier.sql):
// catálogo vendável é free/enterprise; 'professor' é o tier interno do modo
// "PPS para Professores". Os níveis 1 (ex-pro) continuam existindo como
// SEMÂNTICA de feature (canAccessAcademia etc.) — mas nenhum tier vendável
// fica entre 0 e 2, então na prática level>=1 == enterprise/professor.
const PLAN_HIERARCHY: Record<string, number> = { free: 0, enterprise: 2, professor: 2 };

const PLAN_CONFIG: Record<string, { label: string; badgeClass: string }> = {
  free: { label: 'Free', badgeClass: 'bg-muted text-muted-foreground' },
  enterprise: { label: 'Enterprise', badgeClass: 'bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700' },
  professor: { label: 'Professor', badgeClass: 'bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-700' },
};

export function usePlanFeatures() {
  const { club } = useAuth();
  const tier = (club?.plan_tier as string) || 'free';
  const level = PLAN_HIERARCHY[tier] ?? 0;
  const config = PLAN_CONFIG[tier] || PLAN_CONFIG.free;

  return {
    tier,
    level,
    planLabel: config.label,
    planBadgeClass: config.badgeClass,
    // Feature flags
    canAccessCRM: true,
    canAccessOportunidades: level >= 1,
    canAccessAcademia: level >= 1,
    canAccessFinanceiroBasico: level >= 1,
    canAccessERP: level >= 2,
    canAccessCompeticoes: level >= 1,
    canAccessCategorias: true,
    canAccessAgregadores: level >= 1,
    canAccessIntegracoes: level >= 2,
    canAccessPublicSite: level >= 2,
    canAccessNfse: level >= 2,
    canManageFullTeam: level >= 1,
    // CRM limits
    maxLeads: level === 0 ? 50 : Infinity,
    isFreePlan: level === 0,
    isEnterprisePlan: level === 2,
  };
}
